module.exports = __webpack_public_path__ + "img/rogphone3.c0587941.jpg";